/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

Sentry.init({
  dsn: "https://e2f748307cee3d2fff0124439e703e46@sentry.xoverservices.com/11",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
